import SessionService from '@/services/SessionService'
import Case from 'case'
import i18n from '@/i18n'

/**
 * Starts a new session for the specified topic and subtopic.
 *
 * @param {string} topic e.g. "math"
 * @param {string} subtopic e.g. "algebra"
 */
export const startSession = (router, topic, subtopic) =>
  router.push(
    `/${i18n.locale}/session/${Case.kebab(topic)}/${Case.kebab(subtopic)}`
  )

/**
 * Rejoins an existing session.
 * @param {VueRouter} router
 * @param {string} sessionPath
 */
export const rejoinSession = (router, sessionPath) => {
  if (sessionPath) router.push(sessionPath)
}

/**
 * Ends the current session.
 * @param {object} context
 */
export const endSession = (context, skipSocketDisconnect) => {
  const sessionId = context.$store.state.user.session._id
  SessionService.endSession(context, sessionId)
    .then(() => {
      if (!skipSocketDisconnect) context.$socket.disconnect()
      context.$router.replace(`/${i18n.locale}/dashboard`)
      context.$store.dispatch('user/fetch', context)
      context.$store.dispatch('app/modal/hide')
    })
    .catch(() => window.alert('Could not end session'))
}
